<template>
  <div class="groups">
    <back-home-btn></back-home-btn>

    <v-container class="pa-3 pt-5">
      <v-card class="ma-5">
        <v-system-bar color="primary" dark height="35">
          <v-icon left>mdi-account-group</v-icon>
          <span class="text-subtitle-1">グループ所属管理</span>
        </v-system-bar>
        <v-container>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">ユーザー名</th>
                  <th class="text-left">メールアドレス</th>
                  <th class="text-center">削除</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="member in members" :key="member.id">
                  <td>{{ member.name }}</td>
                  <td>{{ member.email }}</td>
                  <td class="text-center">
                    <!-- メンバー削除ボタン -->
                    <v-btn
                      v-if="member.authority == 0"
                      text
                      class="grey--text"
                      @click.stop="openContinueDialog(member)"
                    >
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
                <tr v-if="loading">
                  <td>
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </td>
                  <td>
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <!-- グループ所属ユーザー作成用ボタン -->
                    <v-btn v-if="authUser" text @click.stop="openLogin">
                      <v-icon>mdi-account-plus-outline</v-icon>
                      <span>招待する</span>
                    </v-btn>
                    <invitation-group-member-dialog
                      ref="invitationGroupMemberDialog"
                      :group-id="groupId"
                      :execute-action="invitationMember"
                    />
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <!-- メンバー削除確認ダイアログ -->
          <continue-dialog
            ref="coninueDialog"
            title="確認"
            continue-text="削除する"
            continue-color="error"
            :execute-action="removeMember"
          >
            <template v-if="removeTarget">
              所属ユーザー
              {{
                removeTarget.name
              }}
              をグループから削除してよろしいですか？<br />
            </template>
          </continue-dialog>
        </v-container>
      </v-card>
    </v-container>

    <!-- アカウント登録時メッセージ -->
    <v-snackbar v-model="snackbar" :timeout="10000" bottom color="info" dark>
      入力されたメールアドレス宛に招待メールを送信しました。<br />
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          閉じる
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import InvitationGroupMemberDialog from '../components/feature/InvitationGroupMemberDialog.vue';
import ContinueDialog from '../components/feature/ContinueDialog.vue';
import BackHomeBtn from '../components/common/BackHomeBtn.vue';

export default {
  components: {
    InvitationGroupMemberDialog,
    ContinueDialog,
    BackHomeBtn,
  },
  data: () => ({
    removeTarget: null,
    snackbar: false,
  }),
  computed: {
    ...mapGetters({
      // 認証ユーザー
      authUser: 'auth/authUser',
      // グループ所属メンバー
      members: 'auth/groupMembers',
    }),
    groupId() {
      return this.authUser ? this.authUser.customer_group_id : 0;
    },
    loading() {
      return this.members ? false : true;
    },
  },
  methods: {
    // 所属ユーザー取得
    getMembers() {
      if (!this.authUser) return;
      this.$store.dispatch('auth/loadGroupMembers');
    },
    // ユーザー追加ボタン押下
    openLogin() {
      this.$refs.invitationGroupMemberDialog.open();
    },
    // アカウント作成
    async invitationMember(authData) {
      if (await this.$store.dispatch('auth/registerMember', authData)) {
        this.snackbar = true;
      }
    },
    openContinueDialog(member) {
      this.removeTarget = member;
      this.$refs.coninueDialog.open();
    },
    removeMember() {
      this.$store.dispatch('auth/removeMember', this.removeTarget.id);
      this.removeTarget = null;
    },
  },
  created() {
    if (!this.members) {
      this.getMembers();
    }
  },
  watch: {
    authUser: function() {
      this.getMembers();
    },
  },
};
</script>
